import { Facebook, Instagram, LinkedIn, YouTube } from "@mui/icons-material";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import classNames from "classnames";
import { MouseEventHandler } from "react";
import { useLocation } from "react-router-dom";
import { NavItemProps, platformUrl } from "../../layout/Navigation/Navigation";
import Button from "../../ui/Button/Button";
import CustomLink from "../../ui/Link/Link";
import NavItem from "../../ui/NavItem/NavItem";
import { getPlatform } from "../../utils";

const IconMapping: Record<
	string,
	OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string }
> = {
	YouTube: YouTube,
	Facebook: Facebook,
	Instagram: Instagram,
	LinkedIn: LinkedIn,
};

const NavGroupItems = ({
	items,
	isIconGroup,
	iconSize,
	className,
	functionsAvailableFromConfig,
}: {
	items: NavItemProps[];
	isIconGroup?: boolean;
	iconSize?: string;
	className?: string;
	functionsAvailableFromConfig?: {
		[key: string]: MouseEventHandler<HTMLButtonElement>;
	};
}) => {
	const location = useLocation();

	return items.map((item) => {
		let url: string;
		if (typeof item.url === "string") {
			url = item.url;
		} else if (item.url && (item.url as platformUrl).platform) {
			const platform = getPlatform();
			url = platform.isAndroid
				? (item.url as platformUrl).platform.android
				: (item.url as platformUrl).platform.ios;
		} else {
			url = String(item.url ?? "");
		}
		const isExternal = item?.external ?? false;
		const render = item?.render ?? true;
		const IconComponent = IconMapping[item.label];
		const classes = classNames({
			"primary-action text-dark": item?.variant === "primary",
			"text-light": item?.variant !== "primary",
			selected: location.pathname === url,
			className,
		});

		return (
			render && (
				<NavItem key={item.label}>
					{item?.type === "button" ? (
						<Button
							onClick={functionsAvailableFromConfig![item.label]}
							className={classes}>
							{item.img ? (
								<img
									src={item.img}
									alt={item.label}
									className="button__image"
								/>
							) : (
								item.label
							)}
						</Button>
					) : (
						<CustomLink
							link={{
								label: item.label,
								url,
								type: item?.type,
								img: item?.img,
							}}
							isExternal={isExternal}
							className={classes}
							data-title={item.label}>
							{isIconGroup ? (
								<IconComponent sx={{ fontSize: iconSize || "3rem" }} />
							) : (
								item.label
							)}
						</CustomLink>
					)}
					{item?.additionalContentFrom ?? null}
				</NavItem>
			)
		);
	});
};

export default NavGroupItems;
